import React from "react";
// @ts-ignore
import lottie from "lottie-web/build/player/lottie_light.min.js";
let animationDataMap = new Map();
const Splash = ({ height, pathToAnimation }) => {
    React.useEffect(() => {
        if (document.getElementById("splash") == null)
            throw new Error("Cannot initialize splash");
        const animationData = animationDataMap.get(pathToAnimation);
        const instance = lottie.loadAnimation({
            container: document.getElementById("splash"),
            renderer: "svg",
            loop: true,
            autoplay: true,
            ...{ path: animationData ? undefined : pathToAnimation, animationData },
        });
        const listener = instance.addEventListener("data_ready", () => {
            animationDataMap.set(pathToAnimation, instance.animationData);
        });
        return () => {
            instance.removeEventListener(listener);
            instance.destroy();
        };
    }, [pathToAnimation]);
    return (React.createElement("div", { className: "ukt-splash", "aria-live": "polite", "aria-busy": "true", style: {
            height: height ? height : "100vh",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        } },
        React.createElement("div", { className: "sr-only" }, "Loading is in progress"),
        React.createElement("div", { id: "splash", style: { height: "33%", width: "33%" } })));
};
export default Splash;
//# sourceMappingURL=Splash.js.map